import { WabaProvider } from '../whatsapp/waba-provider';

export interface AccountDetailsModel {
  id: number;
  tenantId?: string;
  stripeCustomerId: number;
  companyName: string;

  companyContactNo: string;
  plan: string;

  affiliateCode: string;
  address: string;
  createdTime: Date;
  active: boolean;
  maxUser?: number;

  storageUsed: number;
  storageLimit: number;
  transactionalEmailSent: number;
  transactionalEmailLimit: number;
  emailCampaignSent: number;
  emailCampaignLimit: number;
  totalWhatsappMessageSent: number;
  totalSmsSent: number;
  smsCredit: number;
  smsCreditUsed: number;

  billingName?: string;
  billingAddress?: string;

  paymentExempted: boolean;

  wabaEmail?: string;
  wabaPassword?: string;
  wabaId?: string;
  wabaToken?: string;
  wabaGuid?: string;
  wabaName?: string;
  wabaPhone?: string;
  wabaPhoneId?: string;
  wabaWebhookId?: string;
  wabaWebhookUrl?: string;
  wabaProvider?: WabaProvider;
  wabaNubitelName?: string;
  wabaMetaName?: string;
  wabaFireMobileName?: string;

  wabaMetaEmail?: string;
  wabaMetaPassword?: string;
  wabaMetaGuid?: string;
  wabaMetaToken?: string;
  wabaMetaId?: string;
  wabaMetaPhone?: string;
  wabaMetaPhoneId?: string;

  wabaFireMobileEmail?: string;
  wabaFireMobilePassword?: string;
  wabaFireMobileGuid?: string;
  wabaFireMobileToken?: string;
  wabaFireMobilePhone?: string;
  wabaFireMobilePhoneId?: string;

  wabaNubitelEmail?: string;
  wabaNubitelPassword?: string;
  wabaNubitelGuid?: string;
  wabaNubitelToken?: string;
  wabaNubitelPhone?: string;
  wabaNubitelPhoneId?: string;

  ipWhitelist?: string;
  ipWhitelistEnabled?: boolean;
}
